import {
    Button,
    Modal,
    Table,
    Row,
    Col,
    Alert,
    Form,
    Input,
    InputNumber,
    Select,
    DatePicker,
    message,
    ConfigProvider,
    theme
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

import { useAuth } from "../../contexts/auth-context";
import {
    getMaintenanceSetting,
    saveMaintenanceHeadsup,
    saveMaintenanceMode
} from '../../rest/admin/maintenance';

import './styles/AdminMaintenance.css';

const AdminMaintenance = (props) => {
    const { transactions = [], inProgress = false } = props;
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [maintenanceHeadsupModal, showMaintenanceHeadsupModal] = useState(false);
    const [maintenanceHeadsupUpdateLoading, setMaintenanceHeadsupUpdateLoading] = useState(false);
    const [error, setError] = useState(null);
    const [maintenanceHeadsupUpdateError, setMaintenanceHeadsupUpdateError] = useState(null);
    const auth = useAuth();
    const loginEmail = auth.currentUser?.email;
    const [maintenanceHeadsupUpdateForm] = Form.useForm();


    const fetchMaintenanceSetting = async () => {
        try {
            const response = await getMaintenanceSetting();
            if (response.data) {
                setData([response.data]);
            }
            setLoadingData(false);
        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setLoadingData(false);
            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setError(errorData.message);
                return;
            }

            setError(error.message);
        }
    }


    const onUpdateMaintenanceMode = async (record) => {
        setLoading(true);

        try {
            await saveMaintenanceMode({ mode: record.mode === 'on' ? 'off' : 'on' });
            const response = await getMaintenanceSetting();
            if (response.data) {
                setData([response.data]);
            }
            setLoading(false);
            message.success(`Maintenance mode turned ${record.mode === 'on' ? 'off' : 'on'}`);

        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setLoading(false);
            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setError(errorData.message);
                return;
            }

            if (errorData && typeof errorData === 'string') { // This means the error is our customized error from the server
                setError(errorData);
                return;
            }

            setError(error.message);
        }
    }

    const showMaintenanceModeModal = (record) => {
        Modal.confirm({
            title: `Are you sure you want to turn ${record.mode === 'on' ? 'off' : 'on'} maintenance mode ?`,
            content: (
                <p>
                    Click yes if you're sure.
                </p>
            ),
            maskClosable: true,
            closable: true,
            visible: false, // Start hidden
            okText: 'Yes',
            onOk: () => {
                onUpdateMaintenanceMode(record);
            },
            onCancel: () => setLoading(false)

        });
    }

    const columns = [
        {
            title: "Maintenance Mode",
            dataIndex: "mode",
            key: "mode",
            fixed: "left",
            width: "150px",
        },
        {
            title: "Headsup",
            dataIndex: "headsup",
            key: "headsup",
            fixed: "left",
            width: "100px",
        },
        {
            title: "Headsup message",
            dataIndex: "headsupMessage",
            key: "headsupMessage",
            // fixed: "left",
            width: "250px",
        },
        
        {
            title: "Headsup Action",
            dataIndex: "",
            key: "x",
            width: "200px",
            render: (_, record) => {
                return (
                    <Button
                        type="primary"
                        style={{ paddingLeft: '10px', paddingRight: '10px' }}
                        disabled={record.archived || loading}
                        onClick={() => {
                            maintenanceHeadsupUpdateForm.setFieldsValue(data[0]);
                            showMaintenanceHeadsupModal(true)
                        }}
                    >
                        Update heads up details
                    </Button>
                )
            },
        },
        {
            title: "Maintenance Mode Action",
            dataIndex: "",
            key: "x",
            width: "250px",
            render: (_, record) => {
                return (
                    <Button
                        type="primary"
                        style={{ paddingLeft: '10px', paddingRight: '10px' }}
                        disabled={loading}
                        onClick={() => showMaintenanceModeModal(record)}
                    >
                        Turn {record.mode === 'on' ? 'off' : 'on' } maintenance mode
                    </Button>
                )
            },
        },
    ];

    const handleMaintenanceHeadsupUpdate = async () => {
        setMaintenanceHeadsupUpdateError('');
        setMaintenanceHeadsupUpdateLoading(true);

        try {
            const formValues = await maintenanceHeadsupUpdateForm.validateFields();
            console.log('Headsup values ==>', formValues);
            if (data[0].headsup === formValues.headsup && data[0].headsupMessage === formValues.headsupMessage) {
                message.info('This is already the saved values. No changes to save!');
                setMaintenanceHeadsupUpdateLoading(false);
            } else {
                await saveMaintenanceHeadsup(formValues);

                const response = await getMaintenanceSetting();
                if (response.data) {
                    setData([response.data]);
                }
                
                message.success('Maintenance headsup updated successfully');
                showMaintenanceHeadsupModal(false);
                setMaintenanceHeadsupUpdateLoading(false);
            }

        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setMaintenanceHeadsupUpdateLoading(false);
            
            // If is AntDesign validation errors, just return as they are already displayed on the screen
            if (error.errorFields?.length) {
                return;
            }
            
            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setMaintenanceHeadsupUpdateError(errorData.message);
                return;
            }

            if (errorData && typeof errorData === 'string') { // This means the error is our customized error from the server
                setMaintenanceHeadsupUpdateError(errorData);
                return;
            }

            setMaintenanceHeadsupUpdateError(error.message);
        }
    }

    useEffect(() => {
        fetchMaintenanceSetting();
    }, [])


    const validateMessages = {
        required: "${label} is required!",
        types: {
            email: "${label} is not a valid email!",
            number: "${label} is not a valid number!",
        },
        number: {
            range: "${label} must be between ${min} and ${max}",
        },
    };

    return (
        <div className="admin-special-payments-page">
            <h2 className="text-center">Punkypay Maintenance Setting</h2>
            {
                error && (
                    <Row style={{ marginBottom: '20px' }}>
                        <Col
                            xs={{ span: 24 }}
                            md={{ span: 16, offset: 4 }}
                            style={{ marginTop: "10px" }}
                        >
                            <Alert className="text-center" title={error} type="error" />
                        </Col>
                    </Row>
                )
            }
            <Table
                columns={columns}
                dataSource={data}
                scroll={{ x: 1024 }}
                loading={loadingData}
            //onRow={onRow}
            />
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                }}
            >
                <Modal
                    title="Update meaintenance headsup"
                    centered
                    open={maintenanceHeadsupModal}
                    onOk={() => handleMaintenanceHeadsupUpdate()}
                    okText="Save maintenance headsup"
                    onCancel={() => showMaintenanceHeadsupModal(false)}
                    confirmLoading={maintenanceHeadsupUpdateLoading}
                // width={700} // width in px
                >

                    {
                        maintenanceHeadsupUpdateError && (
                            <Row style={{ marginBottom: '20px' }}>
                                <Col
                                    xs={{ span: 24 }}
                                    md={{ span: 16, offset: 4 }}
                                    style={{ marginTop: "10px" }}
                                >
                                    <Alert title={maintenanceHeadsupUpdateError} type="error" />
                                </Col>
                            </Row>
                        )
                    }

                    <Form
                        labelCol={{
                            // xs: { span: 24 },
                            // md: { span: 24 }
                        }}
                        wrapperCol={{
                            // xs: { span: 24 },
                            // md: { span: 24 },
                        }}
                        form={maintenanceHeadsupUpdateForm}
                        name="maintenanceHeadsup"
                        // onFinish={onFinish}
                        validateMessages={validateMessages}
                        // style={{  margin: "auto", }}
                        initialValues={data[0]}
                    >

                        <Form.Item
                            name={"headsup"}
                            label={"headsup"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <Select
                                placeholder={"Headsup"}
                                options={[
                                    {value: 'off', label: 'Off'},
                                    {value: 'on', label: 'On'},
                                ]}
                                disabled={maintenanceHeadsupUpdateLoading} 
                            />
                        </Form.Item>
                        <Form.Item
                            name={"headsupMessage"}
                            label={"headsupMessage"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <Input.TextArea
                                placeholder={"Headsup message"}
                                rows={4}
                                disabled={maintenanceHeadsupUpdateLoading}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </ConfigProvider>
        </div>
    );
};

export default AdminMaintenance;
